<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Kategori Agenda</section>
    <!-- Body -->
    <div class="w-full p-5">
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Nama Kategori"
              v-model="nama"
              name="nama"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('nama')">{{
              errors.first("nama")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <v-select :options="listWarnaAgenda" v-model="selectedWarnaAgenda" name="warna" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('warna')">{{
              errors.first("warna")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Deskripsi Kategori"
              v-model="deskripsi"
              name="deskripsi"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('deskripsi')">{{
              errors.first("deskripsi")
            }}</span>
          </div>
        </div>
      </form>
    </div>

    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Update Data 
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import vSelect from "vue-select";
import {UPDATE} from '@/query/kategori-agenda';

export default {
  components : {
    'v-select': vSelect
  },
  props : {
    kategoriAgenda : {
      type : Object
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      keterangan : '',
      nama : '',
      deskripsi : '',
      selectedWarnaAgenda : {value : '', label : 'Pilih kategori surat'},
      listWarnaAgenda: [
        {value: 'success', label: 'Hijau'},
        {value: 'warning', label: 'Kuning'},
        {value: 'danger', label: 'Merah'},
        {value: 'default', label: 'Abu-Abu'},
      ]
    };
  },
  watch: {
    kategoriAgenda: function() {
      this.assignData();
    }
  },
  methods: {
    assignData(){
      this.nama = this.kategoriAgenda.nama;
      this.deskripsi = this.kategoriAgenda.deskripsi;
      this.selectedWarnaAgenda = this.listWarnaAgenda.find(item => item.value == this.kategoriAgenda.warna)
    },
    async handleOnSubmit() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.$apollo.mutate({
            mutation : UPDATE,
            variables : {
              id: this.kategoriAgenda.id,
              input : {
                nama: this.nama,
                deskripsi: this.deskripsi,
                warna: this.selectedWarnaAgenda.value
              }
            }
          })
          .then(() => {
            this.$vs.notify({
              title: "Sukses",
              text: "Berhasil memperbaharui kategori agenda.",
              color: "success"
            });
            this.submitCallback();
            this.toggleActive(false);
          })
          .catch(e => {
            console.error(e);
            this.$vs.notify({
              title: "Gagal",
              text: "Silahkan periksa data anda !",
              color: "danger",
              position: "top-right"
            });
          });
        }
        else{
          this.$vs.notify({
            title: "Silahkan lengkapi formulir terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },
    handleOnCancel() {
      this.toggleActive(false);
    },
    submitCallback() {
      this.$emit("submitCallback", true);
    },
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
  }
};
</script>
